<template>
  <div class="oneFloor">
    <div class="oneFloor-head">
      <el-input size="small" placeholder="搜索流程" v-model="searchVal" @keyup.native.enter="$emit('push',null,searchVal)" @blur="$emit('push',null,searchVal)"></el-input>
      <div class="user">
        <el-avatar :size='32' src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
        <div class="user-info">
          <div class="user-name">{{user ? user.Name : 'Admin'}}</div>
          <div class="user-job" v-if="user">{{user.OrgStructure.Title}}</div>
        </div>
      </div>
    </div>
    <ul class="sort-list">
      <li v-for="item in sortList" :key="item.value" :class="{'active-li':activeVal == item.value}" @click="toggle(item)">{{item.label}}</li>
    </ul>
  </div>
</template>
<script>
import { basic } from "../../../http/api";
export default {
  name: 'oneFloor',
  props: ['userInfo'],
  data() {
    return {
      sortList: [
        { value: 1, label: '由我提交的' },
        { value: 2, label: '待我处理的' },
        { value: 3, label: '我已处理的' },
        { value: 4, label: '抄送给我的' },
      ],
      activeVal: 1,
      searchVal: '',
      user: null
    }
  },
  created() {
    this.getBgUser();
  },
  methods: {
    toggle(item) {
      this.activeVal = item.value;
      this.searchVal = '';
      this.$emit('push', item, "");
    },
    getBgUser() {
      basic('BgUser', 'Get', { key: this.userInfo.UserId }).then(res => {
        this.user = res;
      })
    }
  }
}
</script>
<style scoped lang="less">
.oneFloor {
  width: 200px;
  height: 100%;
  background: #ffffff;
  .oneFloor-head {
    padding: 16px 12px;
    .el-input {
      /deep/ input {
        text-align: center;
        background: #eff1f5;
        border-radius: 16px;
        border: 1px solid #eff1f5;
      }
    }
    .user {
      display: flex;
      align-items: center;
      margin-top: 16px;
      .el-avatar {
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);
      }
      .user-info {
        margin-left: 8px;
        .user-name {
          font-size: 14px;
          font-weight: 400;
          color: #3a4151;
        }
        .user-job {
          font-size: 12px;
          font-weight: 400;
          color: #8391b4;
        }
      }
    }
  }
  .sort-list {
    width: 100%;
    li {
      width: 200px;
      height: 44px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      text-align: center;
      line-height: 44px;
      user-select: none;
      cursor: pointer;
      list-style: none;
    }
    .active-li {
      background: #f7f9fc;
      color: #154f9d;
    }
  }
}
</style>